import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import DashboardPage from './DashboardPage';
import { Button } from '@/components/ui/button';
import { usePaulAccess } from '@/lib/paulAccess';

const Admin = () => {
  const { isPaul, isReady } = usePaulAccess();

  if (!isReady) {
    return (
      <div className="min-h-screen bg-background nebula-bg star-field flex items-center justify-center">
        <p className="text-muted-foreground">Loading...</p>
      </div>
    );
  }

  if (isPaul) {
    return <DashboardPage />;
  }

  return (
    <div className="min-h-screen bg-background nebula-bg star-field flex items-center justify-center px-4">
      <div className="w-full max-w-md rounded-2xl border border-border/60 bg-card/70 backdrop-blur p-6 space-y-6">
        <div className="space-y-2 text-center">
          <p className="text-sm uppercase tracking-[0.3em] text-muted-foreground">Admin Access</p>
          <h1 className="text-2xl font-display font-semibold">Sign in required</h1>
          <p className="text-sm text-muted-foreground">
            Please sign in to access the admin dashboard.
          </p>
        </div>

        <div className="space-y-2">
          <Button asChild className="w-full">
            <Link to="/beta">Sign In</Link>
          </Button>
          <Button asChild variant="outline" className="w-full">
            <Link to="/">Back to Home</Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Admin;
